import { productRepository } from "@/modules/product/repositories";
import { Type } from "./type";
export const productCategoryModule = {
  namespaced: true,
  state: () => ({
    categoryList: [],
    loading: false,
    category: {},
  }),
  getters: {},
  mutations: {
    [Type.PRODUCT_CATEGORY_GET_SUCCESS](state, payload) {
      state.categoryList = [payload.data];
    },
    [Type.PRODUCT_CATEGORY_GET_FAILURE](state, payload) {
      console.log(payload);
    },
  },
  actions: {
    async [Type.PRODUCT_CATEGORY_GET_ASYNC]({ commit }, payload) {
      try {
        const { data } = await productRepository.getCategories();
        commit(Type.PRODUCT_CATEGORY_GET_SUCCESS, data?.data?.result);
      } catch (error) {
        commit(Type.PRODUCT_CATEGORY_GET_FAILURE, error);
      } finally {
      }
    },
  },
};
